// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mI4Y","icon":"styles_icon__3wSz6"};